export default class QuoteModel {
    constructor() {

        this.quoteType = '';
        this.quoteRef = '';
        this.customerRef = '';
        this.insurance = false;
        this.origin = '';
        this.originPort = '';
        this.destination = '';
        this.destinationPort = '';
        this.additionalInformation = '';
        this.valueCurrency = '';
        this.value = 0;
        this.movementDate = '';
        this.deliveryDate = '';
        this.freightTerms = '';
        this.transportMode = '';
        this.hazardous = false;
        this.hazardClass = '';
        this.advisedBy = '';
        this.commodity = '';
        this.files = [];

        this.dimensions = {

            multiLineDims: [],
            totalPieces: 0,
            totalWeight: 0,
            chargeableWeight: 0,
            cubeType: '',
            cube: 0,
            unitOfMeasure: 'metric'

        }
    }
}